import React from "react";

const EligibilitySuccess = ({
  isEligibilitySuccessModalOpen,
  closeEligibilitySuccess,
  loanProductName,
  loanLimit,
  handleContinueCreateLoan,
}) => {
  if (!isEligibilitySuccessModalOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50 p-4 backdrop-blur-sm overflow-y-auto">
      {/* Retained 670px desktop max-width structure with responsive min-height */}
      <div className="bg-white rounded-md shadow-xl w-full max-w-[670px] min-h-[340px] my-auto p-5 sm:p-8 flex flex-col items-center justify-center text-center transition-all">
        {/* Icon Container */}
        <div className="mb-4 sm:mb-6 flex items-center justify-center w-16 h-16 sm:w-[76px] sm:h-[76px] rounded-full bg-blue-100 shrink-0">
          <div className="bg-blue-100 p-2 sm:p-3 rounded-full">
            <img
              src="/blue-tick.png"
              alt="Member Eligible"
              className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
            />
          </div>
        </div>

        {/* Text Content */}
        <div className="w-full max-w-[460px] px-2">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3 break-words">
            Member Eligible
          </h2>

          <p className="text-gray-600 text-xs sm:text-sm mb-6 sm:mb-8 leading-relaxed break-words">
            This member meets all the requirements and is eligible to apply for
            a
            <span className="font-semibold text-gray-900">
              {" "}
              {loanProductName || "[loan_productname]"}
            </span>{" "}
            of up to KES
            <span className="font-semibold text-gray-900">
              {" "}
              {loanLimit
                ? new Intl.NumberFormat("en-KE").format(loanLimit)
                : "0"}
            </span>
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col-reverse sm:flex-row justify-center items-center gap-3 sm:gap-4 w-full">
          <button
            className="w-full sm:w-[211px] h-[45px] sm:h-[49px] border border-[#074073] text-xs sm:text-sm text-[#074073] rounded-md font-medium whitespace-nowrap hover:bg-[#074073] hover:text-white transition-colors duration-200"
            onClick={closeEligibilitySuccess}
          >
            Close
          </button>

          <button
            className="w-full sm:w-[211px] h-[45px] sm:h-[49px] bg-[#074073] text-xs sm:text-sm text-white rounded-md font-medium whitespace-nowrap hover:bg-[#06355d] transition-colors duration-200"
            onClick={handleContinueCreateLoan}
          >
            Continue to Create Loan
          </button>
        </div>
      </div>
    </div>
  );
};

export default EligibilitySuccess;
